import React, { useState, useContext, useEffect } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Auth } from 'aws-amplify';
import { ThemeContext } from 'styled-components';
import { ModalClose } from '../../components';
import bgLogin from '../../assets/images/bg_login.jpg';
import logoNexus from '../../assets/images/logo_nexus_small.png';
import * as s from './styled-signup';

// Icones inline Lucide-style — mesmo padrao do /login e /forgot-password.
const IKey = (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="7.5" cy="15.5" r="3.5" />
    <path d="m10 13 9-9M17 7l3 3" />
  </svg>
);
const ILock = (
  <svg
    className="lead"
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="4" y="11" width="16" height="9" rx="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </svg>
);
const IEye = (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const IEyeOff = (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
    <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24M1 1l22 22" />
  </svg>
);
const IAlert = (
  <svg
    viewBox="0 0 24 24"
    width="14"
    height="14"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 8v4M12 16v.5" />
  </svg>
);
const IBack = (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M19 12H5M12 19l-7-7 7-7" />
  </svg>
);
const ICheck = (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 6 9 17l-5-5" />
  </svg>
);
const IDot = (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <circle cx="12" cy="12" r="4" />
  </svg>
);

const CadastroSenha = () => {
  const history = useHistory();
  const location = useLocation();
  const credentials = location.state || {};
  const [email] = useState(credentials.email || '');
  const [oldPassword] = useState(credentials.password || '');

  useEffect(() => {
    // Sem credenciais no state → não tem como completar o fluxo. Volta ao login.
    if (!credentials.email || !credentials.password) {
      history.replace('/login');
      return;
    }
    // Limpa o state da rota para não persistir credenciais no histórico do
    // navegador. Como ambos já foram capturados nos useStates, podemos limpar.
    history.replace(location.pathname, {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Preload do bg_login pra evitar flash preto (mesma logica do /login).
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = bgLogin;
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const dispatch = useDispatch();
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const [errorMessagePassword, setErrorMessagePassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [modalConfirmation, setModalConfirmation] = useState(false);
  const [modalClose, setModalClose] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showPassConfirm, setShowPassConfirm] = useState(false);
  const { colors } = useContext(ThemeContext);

  const messageByStatus = (event) => {
    if (newPassword < 8) return 'Sua senha deve conter no mínimo 8 caracteres';
    if (event.message === 'Password attempts exceeded')
      return 'Tentativas de senha excedidas';
    if (event.message === 'Incorrect username or password.')
      return 'Link inválido';
    if (event.code === 'UserNotFoundException') return 'Usuário não encontrado';
    if (event.code === 'InvalidParameterException')
      return 'Todos os campos devem ser prenchidos';
    return 'Ocorreu um erro...';
  };

  // Criterios avaliados AO VIVO pro checklist (mesmas regras do submit).
  const criteria = [
    { ok: newPassword.length >= 8, label: 'Mínimo de 8 caracteres' },
    { ok: /\d/.test(newPassword), label: 'Pelo menos um número' },
    { ok: /[a-z]/.test(newPassword), label: 'Letra minúscula' },
    { ok: /[A-Z]/.test(newPassword), label: 'Letra maiúscula' },
    {
      ok: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(newPassword),
      label: 'Caractere especial (!@#$...)',
    },
    {
      ok: newPassword.length > 0 && newPassword === newPasswordConfirm,
      label: 'Senhas conferem',
    },
  ];

  const verifyPasswordCriteria = (password, passwordRepeat) => {
    const isPasswordDifferent = password !== passwordRepeat;
    const isPasswordSmaller = password.length < 8;
    const passwordHasANumber = /\d/.test(password);
    const passwordHasALowerCase = /[a-z]/.test(password);
    const passwordHasAnUpperCase = /[A-Z]/.test(password);
    const passwordHasASpecialCharacter =
      /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);

    if (isPasswordDifferent) {
      setErrorMessagePassword('As senhas não conferem');
      return false;
    }

    if (isPasswordSmaller) {
      setErrorMessagePassword('Sua senha deve conter no mínimo 8 caracteres');
      return false;
    }

    if (!passwordHasANumber) {
      setErrorMessagePassword('A senha deve conter números');
      return false;
    }

    if (!passwordHasALowerCase) {
      setErrorMessagePassword('A senha deve conter letras minúsculas');
      return false;
    }

    if (!passwordHasAnUpperCase) {
      setErrorMessagePassword('A senha deve conter letras maiúsculas');
      return false;
    }

    if (!passwordHasASpecialCharacter) {
      setErrorMessagePassword('A senha deve conter caracteres especiais');
      return false;
    }

    return true;
  };

  const onSubmit = (event) => {
    event.preventDefault();

    if (verifyPasswordCriteria(newPassword, newPasswordConfirm)) {
      Auth.signIn(email, oldPassword)
        .then((data) => {
          dispatch({
            type: 'USUARIO/SET_ERROR',
            erro: '',
          });
          if (data.challengeName === 'NEW_PASSWORD_REQUIRED') {
            Auth.completeNewPassword(data, newPassword)
              .then(() => {
                setModalConfirmation(true);
                dispatch({
                  type: 'USUARIO/SET_ERROR',
                  erro: '',
                });
              })
              .catch((e) => {
                setErrorMessagePassword(messageByStatus(e?.message || e));
                dispatch({
                  type: 'USUARIO/SET_ERROR',
                  error: messageByStatus(e),
                });
                setLoading(false);
              });
          }
          history.replace('/login');
        })
        .catch((e) => {
          dispatch({
            type: 'USUARIO/SET_ERROR',
            error: messageByStatus(e),
          });
          setLoading(false);
          if (e.message === 'Password attempts exceeded') {
            setErrorMessagePassword(messageByStatus(e));
          } else {
            e.message === 'Incorrect username or password.'
              ? setErrorMessagePassword(messageByStatus(e))
              : setErrorMessagePassword(messageByStatus(e));
          }
        });
    }
  };

  const loginRedirect = () => {
    setModalConfirmation(false);
    setModalClose(false);
    dispatch({
      type: 'USUARIO/SET_ERROR',
      erro: '',
    });
    history.push('/login');
  };

  const handleNewPassword = (event) => {
    setNewPassword(event.target.value);
  };

  const handleNewPasswordConfirm = (event) => {
    setNewPasswordConfirm(event.target.value);
    setErrorMessagePassword('');
  };

  const submitDisabled =
    newPassword.length < 8 || newPasswordConfirm.length < 8 || loading;

  return (
    <s.Stage data-screen-label="02 Signup">
      {modalConfirmation && (
        <ModalClose
          labelClose="Senha alterada com sucesso!"
          labelButtonClose="CONCLUIR"
          colorClose={colors.lightblue}
          onClose={() => loginRedirect()}
        />
      )}
      {modalClose && (
        <ModalClose
          onCloseConfirmation={setModalClose}
          onClose={() => loginRedirect()}
        />
      )}

      {/* LEFT — brand panel (escondido em <=1080px via styled). */}
      <s.BrandSide>
        <s.BrandBg $src={bgLogin} />
        <s.BrandOverlay />

        <s.BrandTop>
          <s.BrandMark>
            <img src={logoNexus} alt="Nexus" />
          </s.BrandMark>
        </s.BrandTop>

        <s.BrandHero>
          <s.Eyebrow>
            <span className="pulse" />
            Primeiro acesso
          </s.Eyebrow>
          <s.HeroTitle>
            Defina sua
            <br />
            <span className="accent">nova senha.</span>
          </s.HeroTitle>
          <s.HeroLead>
            Por segurança, o primeiro acesso exige uma senha sua. Crie uma
            forte — os critérios ao lado acendem conforme você digita.
          </s.HeroLead>
        </s.BrandHero>

        <s.BrandFoot>
          <span>© 2026 Higra. Todos os direitos reservados.</span>
        </s.BrandFoot>
      </s.BrandSide>

      {/* RIGHT — form */}
      <s.FormSide>
        <s.FormWrap>
          <s.FormHead>
            <s.FormHeadLbl>{IKey} Redefinição de senha</s.FormHeadLbl>
            <s.FormTitle>Crie sua nova senha</s.FormTitle>
            <s.FormSub>
              Conta: <strong>{email}</strong>
            </s.FormSub>
          </s.FormHead>

          <s.Form onSubmit={onSubmit}>
            <s.Field $error={!!errorMessagePassword}>
              <s.FieldLabel htmlFor="signup-new-password">
                Nova senha
              </s.FieldLabel>
              <s.Ctrl>
                {ILock}
                <input
                  id="signup-new-password"
                  type={showPass ? 'text' : 'password'}
                  maxLength="10"
                  placeholder="••••••••"
                  autoComplete="new-password"
                  value={newPassword}
                  onChange={handleNewPassword}
                  aria-invalid={!!errorMessagePassword}
                />
                <s.ToggleEye
                  onClick={() => setShowPass((p) => !p)}
                  title={showPass ? 'Ocultar' : 'Mostrar'}
                  aria-label={showPass ? 'Ocultar senha' : 'Mostrar senha'}
                >
                  {showPass ? IEyeOff : IEye}
                </s.ToggleEye>
              </s.Ctrl>
            </s.Field>

            <s.Field $error={!!errorMessagePassword}>
              <s.FieldLabel htmlFor="signup-confirm-password">
                Confirmar senha
              </s.FieldLabel>
              <s.Ctrl>
                {ILock}
                <input
                  id="signup-confirm-password"
                  type={showPassConfirm ? 'text' : 'password'}
                  maxLength="10"
                  placeholder="••••••••"
                  autoComplete="new-password"
                  value={newPasswordConfirm}
                  onChange={handleNewPasswordConfirm}
                  aria-invalid={!!errorMessagePassword}
                  aria-describedby={
                    errorMessagePassword ? 'signup-form-error' : undefined
                  }
                />
                <s.ToggleEye
                  onClick={() => setShowPassConfirm((p) => !p)}
                  title={showPassConfirm ? 'Ocultar' : 'Mostrar'}
                  aria-label={
                    showPassConfirm ? 'Ocultar senha' : 'Mostrar senha'
                  }
                >
                  {showPassConfirm ? IEyeOff : IEye}
                </s.ToggleEye>
              </s.Ctrl>
            </s.Field>

            {/* Checklist ao vivo dos criterios (substitui o TipPassword
                flutuante) — acende verde conforme atende. */}
            <s.RuleList aria-label="Critérios da senha">
              {criteria.map((c) => (
                <s.RuleItem key={c.label} $ok={c.ok}>
                  {c.ok ? ICheck : IDot}
                  {c.label}
                </s.RuleItem>
              ))}
            </s.RuleList>

            {errorMessagePassword && (
              <s.Hint id="signup-form-error" role="alert">
                {IAlert}
                {errorMessagePassword}
              </s.Hint>
            )}

            <s.Submit disabled={submitDisabled}>
              Redefinir senha
            </s.Submit>

            <s.BackToLogin
              type="button"
              onClick={() => setModalClose(true)}
            >
              {IBack}
              Voltar ao login
            </s.BackToLogin>
          </s.Form>
        </s.FormWrap>
      </s.FormSide>
    </s.Stage>
  );
};

export default withRouter(CadastroSenha);
